import React from "react";
import { Alert } from "antd";
import useLang from "../../hooks/useLang";
import { getEnabledCategoryKeys } from "../../utils/bulkOperationsConfig";
import BulkOpsHeader from "./components/BulkOpsHeader";
import CategoryCard from "./components/CategoryCard";
import { CATEGORIES } from "./categoryRegistry";

const BulkOrderOperations = () => {
	const { strings } = useLang("bulkOrderOperations");
	const categoryStrings = strings?.categories;

	const enabledKeys = getEnabledCategoryKeys();
	const categories = CATEGORIES.filter((c) => enabledKeys.includes(c.key));

	return (
		<div className="max-w-5xl mx-auto px-4 py-6 flex flex-col gap-6">
			<BulkOpsHeader
				title={strings?.title ?? "Bulk Order Operations"}
				subtitle={
					strings?.subtitle ?? "Pick a category of bulk operations"
				}
			/>

			{categories.length === 0 ? (
				<Alert
					type="info"
					showIcon
					message={
						strings?.noCategories ??
						"No bulk operation categories are enabled for this country."
					}
				/>
			) : (
				<div className="grid grid-cols-1 md:grid-cols-3 gap-3">
					{categories.map((category) => (
						<CategoryCard
							key={category.key}
							label={
								categoryStrings?.[category.stringsKey]?.label ??
								category.fallbackLabel
							}
							description={
								categoryStrings?.[category.stringsKey]
									?.description ??
								category.fallbackDescription
							}
							icon={category.icon}
							to={`/bulk-order-operations/${category.key}`}
						/>
					))}
				</div>
			)}
		</div>
	);
};

export default BulkOrderOperations;
